<template>
  <div class="d-flex flex-column">
    <div class="grid-header">
      <h1>{{ $t("agentes.titulo") }}</h1>
      <div class="toolbar">
        <button type="button" @click.prevent="crearAgente()" class="btn btn-link">
          <i class="fa-solid fa-plus"></i>
        </button>
      </div>
    </div>

    <DxDataGrid v-bind="getDefaultGridProperties()" :data-source="gridSource" ref="grid"
      class="dx-card wide-card grid-agentes">
      <DxColumnFixing :enabled="true" />
      <DxColumn data-field="Nombre" :caption="$t('agentes.grid.nombre')"></DxColumn>
      <DxColumn data-field="Apellidos" :caption="$t('agentes.grid.apellidos')"></DxColumn>
      <DxColumn data-field="Email" :caption="$t('agentes.grid.email')"></DxColumn>
      <DxColumn data-field="Documento" :caption="$t('agentes.grid.dni_nie')"></DxColumn>
      <DxColumn data-field="Telefono" :caption="$t('agentes.grid.telefono')"></DxColumn>
      <DxColumn data-field="Direccion" :caption="$t('agentes.grid.direccion')"></DxColumn>
      <DxColumn data-field="TramitesActivadosUltimoMes" :caption="$t('agentes.grid.tramites_activados_ultimo_mes')"
        data-type="number"></DxColumn>
      <DxColumn data-field="TramitesActivadosTotales" :caption="$t('agentes.grid.tramites_activados_totales')"
        data-type="number"></DxColumn>
      <DxColumn type="buttons" :caption="$t('agentes.grid.acciones')" :fixed="true"
        fixed-position="right" :buttons="[
          {
            cssClass: 'btn btn-link text-decoration-none btn-sm',
            icon: 'fa-regular fa-edit text-success',
            hint: $t('agentes.grid.modificar'),
            onClick: (e: any) => verDetalle(e.row.data.Id)
          },
          {
            cssClass: 'btn btn-link text-decoration-none btn-sm',
            icon: 'fa-regular fa-trash text-success',
            hint: $t('agentes.grid.borrar'),
            onClick: (e: any) => borrar(e.row.data.Id),
            disabled: (options: any) => options.row?.data.FechaBaja != null || options.row?.data.Id === currentUserId
          }
        ]"/>

    </DxDataGrid>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { DxDataGrid, DxColumn, DxColumnFixing } from "devextreme-vue/data-grid";
import { getDefaultGridProperties } from "@helpers/grid-helper";
import { useApi } from "@api/integration";
import type CustomStore from "devextreme/data/custom_store";
import { useIntl } from "@services/i18n";
import { useModalService } from "@services/modal-service";
import { messageBoxResult } from '@components/dialogs/message-box';
import { type DXLoadOptions } from "@/.shared/.api";
import { toastError, toastSuccess } from "@/.shared/services/notification-service";
import { CreateAgente } from "@/components/agentes/models/CreateAgente";
import AgenteForm from "@/components/agentes/AgenteForm.vue";
import { ExtendedUserInfo, useAuthentication } from "@/.shared/services/auth";

const intl = useIntl();
const api = useApi();
const grid = ref<DxDataGrid>();
const gridSource = ref<CustomStore>();
const modal = useModalService();
const authentication = useAuthentication();

const currentUserId = computed(() => (authentication.userInfo as ExtendedUserInfo)?.idUsuario);

onMounted(async () => {
  setDataSource();
});

async function crearAgente() {
  let title = `${intl.i18n.t("agente.creacion.titulo")}`;
  modal.showModal(
    AgenteForm,
    { model: new CreateAgente(), isEditMode: false },
    { title: title, width: 800, height: 700 }
  ).then((value) => {
    if (value == messageBoxResult.ok)
      grid.value?.instance?.refresh();
  });
}

const setDataSource = async () => {

  gridSource.value = api.apiStore({
    key: "Id",
    load: async (p) => {
      const q = p as DXLoadOptions;
      return await api.callStandardApi("getAgentesForGrid", { showLoading: false }, q)
    }
  });
}

const verDetalle = async (id: string) => {
  let title = `${intl.i18n.t("agentes.edicion.titulo")}`;
  modal.showModal(
    AgenteForm,
    { model: await api.callStandardApi("getAgenteById", { showLoading: true }, id), isEditMode: true },
    { title: title, width: 800, height: 700 }
  ).then((value) => {
    if (value == messageBoxResult.ok)
      grid.value?.instance?.refresh();
  });
}

const borrar = async (id: string) => {
  let respuesta = await modal.messageBox(intl.i18n.t('agentes.grid.borrar_pregunta'), intl.i18n.t('agentes.grid.titulo_confirma_borrar'), "okCancel", "warning");
  if (respuesta == messageBoxResult.ok)
    await api.callStandardApi("deleteAgente", { showLoading: true }, id)
      .then(() => {
        toastSuccess(intl.i18n.t('agentes.borrado_exito'));
        grid.value?.instance?.refresh();
      })
      .catch(() => toastError(intl.i18n.t('agentes.borrado_fallo')));
}

</script>

<style lang="scss" scoped>





</style>